var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-button-loading"},[_c('span',{staticClass:"c-button-loading__icon"}),_vm._v(" "),_c('span',{staticClass:"c-button-loading__icon"}),_vm._v(" "),_c('span',{staticClass:"c-button-loading__icon"})])
}]

export { render, staticRenderFns }